import { Box } from "@material-ui/core";
import BatchInitReserveItem from "./BatchInitReserveItem";
import ConfigureReserveAsCollateralItem from "./ConfigureReserveAsCollateralItem";
import SetActivateReserveItem from "./SetActivateReserveItem";
import SetPoolPauseItem from "./SetPoolPauseItem";
import SetReserveFactorItem from "./SetReserveFactorItem";
import SetReserveInterestRateStrategyAddressItem from "./SetReserveInterestRateStrategyAddressItem";

export default function CollapseItem({ request }) {
  return (
    <Box p="1.5rem">
      {request.name == "setReserveFactor" && <SetReserveFactorItem data={request["data"]} />}
      {request.name == "setReserveInterestRateStrategyAddress" && (
        <SetReserveInterestRateStrategyAddressItem data={request["data"]} />
      )}
      {request.name == "configureReserveAsCollateral" && <ConfigureReserveAsCollateralItem data={request["data"]} />}
      {request.name == "setPoolPause" && <SetPoolPauseItem data={request["data"]} />}
      {(request.name == "deactivateReserve" || request.name == "activateReserve") && (
        <SetActivateReserveItem data={request["data"]} isActivate={request.name == "activateReserve"} />
      )}
      {request.name == "batchInitReserve" && <BatchInitReserveItem data={request["data"]} />}
    </Box>
  );
}
